import { BagCheckedIcon } from './BagCheckedIcon';

/**
 * author: Google
 * id 2D40D813-D1C8-4190-8010-012467F9E48F
 * name bag-checked
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-checked.svg
 * tags
 * - Transportation + Flying 
 */
export const LuggageIcon = BagCheckedIcon;
export default LuggageIcon